<template>
    <div class="m-3">
      <div
        v-for="report in reports"
        v-html="report.iframe"
        class="d-inline-block" />
    </div>
</template>

<script>

  export default {
		name: 'StaticDashboard',
    computed: {
		  reports() {
		    return Object.values(this.$store.state.customReports.items);
      }
    }
	};
</script>

<style scoped>

</style>
